import { Reveal, Eyebrow } from "@/components/site/Reveal";

const ITEMS = [
  ["Beet Root Powder", "Natural nitrates your body converts into nitric oxide to help vessels open wide."],
  ["L-Arginine", "The raw material your body uses to make nitric oxide and keep levels steady."],
  ["L-Citrulline DL-Malate", "Works with L-Arginine to push NO higher for longer; malate supports energy."],
  ["Niacin (B3)", "Supports healthy, flexible blood vessels so blood can flow where it counts."],
  ["Horny Goat Weed", "Contains icariin, long used to support performance and help protect cGMP."],
  ["Ginkgo Biloba", "Antioxidant support to help protect blood vessels and circulation."],
  ["Dong Quai", "A traditional circulatory tonic supporting healthy blood flow."],
  ["D-Aspartic Acid", "An amino acid that supports the body's natural testosterone production."],
];
const WAYS = ["Nitrates that convert into nitric oxide", "Amino acids to maintain steady NO levels", "Antioxidants that support nitric oxide synthase", "Support for mental clarity", "Helps keep blood vessels healthy"];
const QUOTES = [
  ["First time in over two years I didn't have to think about it — it just worked.", "Steve W."],
  ["Three weeks in and my wife actually asked what changed. That conversation alone was worth it.", "David S."],
];

export const NitricIngredients = () => (
  <section id="ingredients" className="bg-[#140A0C] py-24 sm:py-32" data-testid="nitric-ingredients-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
        <Reveal className="lg:col-span-5">
          <Eyebrow className="!text-[#FF4D4D]">One scoop · eight ingredients</Eyebrow>
          <h2 className="mt-5 font-display text-4xl font-bold leading-[1.02] tracking-tight text-[#F2EDE4] sm:text-5xl">
            All pointed at <span className="font-serif italic font-normal text-[#FF4D4D]">one target.</span>
          </h2>
          <p className="mt-5 text-base text-[#F2EDE4]/75">According to the maker, Nitric Boost helps your body make more nitric oxide and protect cGMP:</p>
          <ul className="mt-6 space-y-3" data-testid="nitric-ways">
            {WAYS.map((w) => (
              <li key={w} className="flex items-start gap-3 text-sm text-[#F2EDE4]/85"><span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-[#FF4D4D]" />{w}</li>
            ))}
          </ul>
        </Reveal>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:col-span-7">
          {ITEMS.map(([n, d], i) => (
            <Reveal key={n} delay={(i % 2) * 0.08} className="h-full">
              <div className="h-full rounded-[1.5rem] border border-[#F2EDE4]/10 bg-[#1F1013] p-6 transition-[transform,background-color] duration-500 hover:-translate-y-1 hover:bg-[#2A1418]" data-testid={`nitric-ingredient-${i}`}>
                <span className="font-mono text-xs text-[#FF4D4D]">0{i + 1}</span>
                <h3 className="mt-3 font-display text-xl font-bold text-[#F2EDE4]">{n}</h3>
                <p className="mt-2 text-sm leading-relaxed text-[#F2EDE4]/75">{d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export const NitricQuotes = () => (
  <section className="bg-[#F2EDE4] py-24 sm:py-28" data-testid="nitric-quotes-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <Eyebrow className="!text-[#C62F2F]">In their words</Eyebrow>
        <p className="mt-3 text-sm text-[#140A0C]/65">Customer quotes as published on the official Nitric Boost website.</p>
      </Reveal>
      <div className="mt-10 grid grid-cols-1 items-stretch gap-5 lg:grid-cols-12">
        <Reveal className="lg:col-span-5">
          <div className="overflow-hidden rounded-[2rem]">
            <img src="/nitric-customers.webp" alt="Nitric Boost customers with their jars" data-testid="nitric-customers-image" className="aspect-square w-full object-cover transition-transform duration-1000 hover:scale-105" />
          </div>
        </Reveal>
        <div className="grid grid-cols-1 gap-5 lg:col-span-7">
        {QUOTES.map(([q, n], i) => (
          <Reveal key={n} delay={i * 0.1} className="h-full">
            <figure className="flex h-full flex-col justify-between rounded-[2rem] bg-[#140A0C] p-8 sm:p-10" data-testid={`nitric-quote-${i}`}>
              <blockquote className="font-serif text-3xl italic leading-tight text-[#F2EDE4] sm:text-4xl">“{q}”</blockquote>
              <figcaption className="mt-8 font-mono text-xs uppercase tracking-[0.2em] text-[#FF4D4D]">— {n}</figcaption>
            </figure>
          </Reveal>
        ))}
        </div>
      </div>
    </div>
  </section>
);
